import React from "react";
import { useNavigate } from "react-router-dom";


function About() {
    const navigate = useNavigate()
    return (
        <div className="flex flex-col items-center p-6 bg-white w-full">
            <h3
                className="w-full text-right cursor-pointer text-gray-700 hover:text-blue-500 hover:underline transition duration-200 ease-in-out"
                onClick={() => navigate('/privacy-policy')}>Privacy Policy</h3>
            <h1 className="text-4xl font-bold text-gray-800 text-center mb-6">
                About <span className="text-red-500">Toctic</span>
            </h1>

            <p className="text-lg text-gray-700 text-justify max-w-4xl mb-8">
                Welcome to <span className="text-red-500">Toctic</span>, the ultimate app for creating, sharing, and discovering viral short videos! Whether you're showcasing your talent, sharing a fun moment, or engaging with the latest trends, Toctic makes it easy to express yourself and connect with a global audience. Scroll through endless content, follow your favorite creators, and join the trends that everyone is talking about!
            </p>

            <h2 className="text-3xl font-semibold text-gray-800 mb-4">
                Key Features
            </h2>

            <div className="text-lg text-gray-700 max-w-2xl space-y-6">
                <div>
                    <span className="font-semibold text-gray-800">
                        🎥 Create & Share Videos:
                    </span>{" "}
                    Easily record, edit, and post short videos with powerful built-in tools, effects, and filters. Let your creativity shine!

                    🔥 Discover Trending Content: Explore a personalized feed filled with trending videos, viral challenges, and the latest entertainment from creators around the world.
                </div>

                <div>
                    <span className="font-semibold text-gray-800">
                        📢 Engage with the Community:
                    </span>{" "}
                    Like, comment, and share videos to interact with content that speaks to you. Follow your favorite creators and grow your own fanbase!
                </div>

                <div>
                    <span className="font-semibold text-gray-800">
                        🎶 Massive Music & Sound Library:
                    </span>{" "}
                    Add the perfect soundtrack to your videos with a huge collection of trending songs, sound effects, and voice filters.
                </div>

                <div>
                    <span className="font-semibold text-gray-800">📲 Seamless Sharing:</span> Instantly share your videos across other social platforms and let your content go viral with just one click!
                </div>

                <div>
                    <span className="font-semibold text-gray-800">📩 In-App Messaging:</span>{" "}
                    Chat directly with friends and creators, collaborate on content, and stay connected with your favorite people.
                </div>
                <div>
                    <span className="font-semibold text-gray-800">📌 Personalized Feed:</span>{" "}
                    Our smart algorithm curates a feed based on your interests, ensuring you never miss the content you love.
                </div>
                <div>
                    <span className="font-semibold text-gray-800">📧 Contact Us:</span>
                    If you have any questions regarding privacy while using the
                    Application, please contact us via email at{" "}
                    <a
                        href="mailto:brian@simationstudios.com"
                        className="text-blue-500 underline"
                    >
                        brian@simationstudios.com
                    </a>
                    .
                </div>
            </div>


            <p className="text-lg text-gray-800 text-center max-w-4xl mt-8">
                With <span className="text-red-500">Toctic</span>, entertainment is just a tap away. Join the community, create engaging videos, and become the next viral sensation. Download now and start your journey on Toctic today! 🚀
            </p>
        </div>
    )
}

export default About;